import Vue from "vue";

export default {
  createExemption({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      Vue.$http
        .post("/hrm/exemptions", data)
        .then(response => {
          Vue.$notification.success(response.message);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  getExemptionById(id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/exemptions/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateExemption({ commit }, { data, id }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      Vue.$http
        .put(`/hrm/exemptions/${id}`, data)
        .then(response => {
          commit("tableLoader", false);
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  getMyExemption({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
        ...(state.filterDate != null && { start_date: state.filterDate[0] }),
        ...(state.filterDate != null && { end_date: state.filterDate[1] }),
      };

      Vue.$http
        .get("/hrm/exemptions/employee", { params })
        .then(response => {
          commit("exemptionsData", response.data.results);
          commit("exemptionTotal", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  approveMultipleExemption(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("hrm/exemptions/approve", id)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  rejectMultipleExemption(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("hrm/exemptions/reject", id)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getExemption({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/exemptions/${id}`)
        .then(response => {
          commit("currentExemption", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteExemption(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/exemptions/[${id}]`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllApprovals({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
      };

      Vue.$http
        .get("hrm/exemptions/approval/requests", { params })
        .then(response => {
          commit("exemptionApproval", response.data.results);
          commit("exemptionApprovalTotal", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getApproval({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/exemptions/${id}`)
        .then(response => {
          commit("currentApproval", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  changeApprovalStatus({ ids, endpoint }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/exemptions/${endpoint}`, { exemption_request_ids: ids })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getMyExemption");
    dispatch("getAllApprovals");
  },
  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getMyExemption");
    dispatch("getAllApprovals");
  },
  approveExemptionStatus(_, { ids, endpoint }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/exemptions/${endpoint}`, { exemption_request_ids: ids })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  rejectExemptionStatus(_, { ids, endpoint }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/exemptions/${endpoint}`, {
          id: ids,
        })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
